export const SET_IRQ_MODAL_LABEL = {
  HEADER: 'Inherent Risk questionnaire validation',
  CURRENT_IR: 'Current IR',
  ENGAGEMENT_ENABLED_HEADER: 'Inherent Risk',
  OVERVIEW: 'Overview',
  ESTIMATED_IR: 'Estimated IR',
  ESTIMATED_IR_WITH_COLON: 'Estimated IR:',
  CALCULATED_IR_WITH_COLON: 'Calculated IR:',
  ESTIMATED_IR_DESCRIPTION:
    'This is an AI-generated estimate based on available data. Validate it by completing the questionnaire, or skip ahead to assign the Inherent Risk directly.',
  PRE_FILL_ANSWERS_FROM: 'Pre-fill answers from:',
  ASSIGN_INHERENT_RISK: 'Assign Inherent Risk',
  ASSIGN_RISK_HEADING: (name: string) =>
    name ? `Assign an Inherent Risk to ${name}` : 'Assign an Inherent Risk',
  ENGAGEMENTS: 'Engagements',
  CALCULATED_IR: 'Calculated IR',
  START_VALIDATION: 'Start IRQ validation',
  SKIP_AND_ASSIGN: 'Skip and assign Inherent Risk',
  CONTINUE_TO_ASSIGN: 'Continue to assign',
  ASSIGN_AND_FINISH: 'Assign & finish',
  COMMENT: 'Comment',
  COMMENT_OPTIONAL: '(optional)',
  COMMENT_PLACEHOLDER: 'Document context on this change in a comment.',
  SELECT_OPTIONS: 'Select options',
  CANCEL: 'Cancel',
  BACK: 'Back',
  NEXT: 'Next',
  CLOSE: 'Close',
  APPLY_ALL: 'Apply all',
  REMOVE_ALL: 'Remove all',
  LEMA_AI_SUGGESTIONS: 'Lema AI suggestions',
  LEMA_SMART_ESTIMATION: 'Public Data',
  LEMA_INTAKE: 'Lema Intake',
  INTAKE_BODY: 'Based on information provided in the intake request.',
} as const
